import Vue from "vue";
import apiList from "@/service/apiList";
import { Message } from "element-ui";
import { api } from "@/service/api";
import apiList2 from "@/service/basic/aftersaleApiList";
import service from "@/service/chat_api";
const echarthost = echarthostname;
const myhost = myhostname;

// 获取售后单状态
function getAsOrderStatus(params) {
  const isZhifaOrFactory =
    localStorage.getItem("shop_type") === "1" ||
    localStorage.getItem("shop_type") === "2";
  if (!isZhifaOrFactory) {
    return new Promise(resolve => {
      Vue.prototype.$api
        .get(apiList.asOrderStatus, params)
        .then(function(res) {
          let newArray = [];
          for (let i in res.data) {
            newArray.push({ label: res.data[i], value: i });
          }
          resolve(newArray);
        })
        .catch(function(err) {
          console.log(err);
        });
    });
  } else {
    //获取售后单售后状态（工厂|直发）
    return new Promise((resolve, reject) => {
      api
        .get(echarthost + apiList2.asOrderStatusEnum, params)
        .then(res => {
          let newArray = [];
          for (let i in res.data) {
            newArray.push({ label: res.data[i], value: i });
          }
          resolve(newArray);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

// 获取售后单类型
function getAsOrderType(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .get(apiList.asOrderType, params)
      .then(function(res) {
        // resolve(res.data)
        let newArray = [];
        for (let i in res.data) {
          newArray.push({ label: res.data[i], value: i });
        }
        resolve(newArray);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 获取售后单列表
function getAftersaleList(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .get(apiList.aftersaleList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取售后单列表
function getBigaftersaleList(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .get(apiList.bigaftersaleList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 获取售后单明细
function getAftersaleDetail(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .get(apiList.aftersaleDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取售后单明细
function getBigaftersaleDetail(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .get(apiList.bigaftersaleDetail, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 售后确认接受退款(退货)
function acceptRefund(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.acceptRefund, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("保存成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 售后确认接受换货(换货)
function acceptExchange(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.acceptExchange, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("保存成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 售后收货
function receiptByShop(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.receiptByShop, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("保存成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 售后确认接受维修(维修)
function acceptRepair(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.acceptRepair, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("保存成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 关闭售后单
function closeAftersale(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.closeAftersale, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("关闭成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 延长商品确认
function receiptDelay(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.receiptDelay, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("关闭成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 售后出库
function shippedByShop(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.shippedByShop, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("售后出库成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 售后出库
function bigshippedByShop(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.bigshippedByShop, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success("售后出库成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 直发发货清单
function shippingList(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.shippingList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 直发发货清单
function bigshippingList(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.bigshippingList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 三方售后维修发货清单
function AfterDeliveryList(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .post(apiList.AfterDeliveryList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

// 售后打印箱码
function printBox(params) {
  return new Promise(resolve => {
    // console.log(params)
    Vue.prototype.$api
      .get(apiList.printBox, params)
      .then(function(res) {
        console.log(res);
        if (res.message === "Success") {
          // Message.success('关闭成功')
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 导出售后单列表
function exportAftersaleList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.downLoadAfterOrder, params)
      .then(function(res) {
        if (res.message === "Success") {
          // Message.success('导出售后单成功，请在邮箱中查收!今日已导出' + res.data + '次')
          Message.success(
            "售后管理报表导出成功，请在报表中心查看下载！今日已导出" +
              res.data +
              "次"
          );
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取售后箱码
function getAfterListBox(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getAfterListBox, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取售后箱码
function getBigafterListBox(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.biggetAfterListBox, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取关闭原因
function getCloseReason(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getAfterCloseReason, params)
      .then(function(res) {
        resolve(res);
      });
    // .catch(function (err) {
    //   console.log(err)
    // })
  });
}
// 获取三方待确认的售后单数量
function getAfterSaleNeedConfirmByReturnCount(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getAfterSaleNeedConfirmByReturnCount, params)
      .then(function(res) {
        resolve(res);
      });
    // .catch(function (err) {
    //   console.log(err)
    // })
  });
}
// 三方售后确认（仅平台，退款类型的售后单）
function afterSaleConfirmByReturn(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.afterSaleConfirmByReturn, params)
      .then(function(res) {
        resolve(res);
      });
    // .catch(function (err) {
    //   console.log(err)
    // })
  });
}
function getServiceNowTime(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getServiceNowTime, params)
      .then(function(res) {
        resolve(res);
      });
  });
}
function saveNotSystemLogisticsByAfterSale(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.saveNotSystemLogisticsByAfterSale, params)
      .then(function(res) {
        resolve(res);
      });
  });
}
function getAfterSaleCourierList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.getAfterSaleCourierList, params)
      .then(function(res) {
        resolve(res);
      });
  });
}

// 售后订单&大单列表（直发|工厂）2022-11-16新增
function getNewASList(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.getNewList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 物流状态枚举
function getBoxStatus(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.getBoxStatus, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 订单快递单号（直发|工厂）
function getTransportList(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.getTransportList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

// 订单包裹-物流轨迹（直发|工厂）
function getPackagetrace(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.getPackagetrace, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 2023-10-10 新增接口--start--
function getWorkOrderList(params = {}) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${apiList2.getWorkOrderList}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

//待处理消息（Top10）- 包含售后、拒收消息
function queryPendingMsgTop(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.queryPendingMsgTop, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
//待处理消息（列表）- 包含售后、拒收消息
function queryPendingMsg(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.queryPendingMsg, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

//售后时效
function queryAsTimeLine(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.queryTimeLine, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
//售后标准
function queryAsStandard(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.queryStandard, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}

function queryAsInfo(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(echarthost + apiList2.queryOrderInfo, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        reject(err);
        console.log(err);
      });
  });
}
// 2023-10-10 新增接口--end--
export {
  getAsOrderStatus,
  getAsOrderType,
  getAftersaleList,
  getAftersaleDetail,
  acceptRefund,
  acceptExchange,
  receiptByShop,
  acceptRepair,
  closeAftersale,
  receiptDelay,
  shippedByShop,
  shippingList,
  AfterDeliveryList,
  printBox,
  exportAftersaleList,
  getAfterListBox,
  getCloseReason,
  getAfterSaleNeedConfirmByReturnCount,
  afterSaleConfirmByReturn,
  getServiceNowTime,
  saveNotSystemLogisticsByAfterSale,
  getAfterSaleCourierList,
  getBigaftersaleList,
  getBigaftersaleDetail,
  bigshippedByShop,
  bigshippingList,
  getBigafterListBox,
  getNewASList,
  getBoxStatus,
  getTransportList,
  getPackagetrace,
  getWorkOrderList,
  queryPendingMsgTop,
  queryPendingMsg,
  queryAsTimeLine,
  queryAsStandard,
  queryAsInfo
};



// WEBPACK FOOTER //
// ./src/models/aftersaleModel.js